import styled from "styled-components";
import { Typography } from "@material-ui/core";

export const TypographyWithAsterisk = styled(Typography)`
  &::after {
    content: " *";
    color: ${(p) => p.theme.palette.warning.main};
  }
`;
